import { DNA } from "react-loader-spinner";

const DnaOverlayLoader = () => {
  return (
    <div
      className="dna-loader-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        backdropFilter: "blur(2px)",
      }}
    >
      <DNA
        visible={true}
        height="120"
        width="120"
        ariaLabel="dna-loading"
        dnaColorOne="f9447f"
        dnaColorTwo="004aad"
      />
    </div>
  );
};

export default DnaOverlayLoader;
